export default "__VITE_ASSET__9b7f6330__"